import { createReducer } from '@reduxjs/toolkit';
import { setReCaptchaAsLoaded } from '@epi-actions/reCaptchaActions';

interface ReCaptchaState {
  isLoaded: boolean;
}

export const initialReCaptchaState: ReCaptchaState = {
  isLoaded: false
};

export const reCaptchaReducer = createReducer(initialReCaptchaState, builder =>
  builder.addCase(setReCaptchaAsLoaded, state => {
    state.isLoaded = true;
  })
);
